<app-scroll-spy-menu></app-scroll-spy-menu>

<app-default-card
  [title]="'Angebot für Ihr Einspeisermanagement'"
  [info]="''"
  [showChildComponent]="true"
  [showThisComponent]="true">
  <ng-container *ngIf="'customerFeedInAcceptanceIntroText' | uiAdaptionValue as infoHtml; else defaultText">
    <div [innerHTML]="infoHtml | safeHtmlPipe"></div>
  </ng-container>
  <ng-template #defaultText>
    <p>
      Sie oder ihr zuständiger Elektro-Fachbetrieb wollen eine Einspeiseranlage bei uns im Netz anmelden.
      Anbei erhalten Sie das Angebot für das benötigte Einspeisermanagement.
      <br />
    </p>
  </ng-template>
</app-default-card>

<app-default-card [title]="'Daten zu Ihrer Netzanmeldung'" [info]="''">
  <section>
    <h3>Technische Einrichtung zur Reduzierung der Einspeiseleistung</h3>
    <form-row>
      <app-feedin-management-summary
        *ngIf="model"
        [companyLocation]="model.companyLocation"
        [feedInManagementInfo]="model.feedInManagementInfo"
        [totalPower]="model.newInstalledPower || model.newProduction"
        [showConfirmationBody]="true"
        [producers]="model.producers"
        [pvModules]="model.pvModules"></app-feedin-management-summary>
    </form-row>
  </section>

  <!--  <section *ngIf="">-->
  <!--    <h3></h3>-->
  <!--  </section>-->
</app-default-card>

<app-gr-confirm-feedin-order-form
  #form
  (onErrorsChanged)="onFormErrorsChanged($event)"></app-gr-confirm-feedin-order-form>

<app-default-card [title]="'Abschluss'" [info]="''" [showChildComponent]="true" [showThisComponent]="true">
  <!-- <form-row>
    <div class="button-container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" fxFlex>
      <app-custom-button
        [title]="'PDF erzeugen'"
        (onClick)="generateDocument()">
      </app-custom-button>
    </div>
  </form-row> -->
  <app-form-confirmation
    [actions]="actions"
    [actionConfirm]="'AcceptFeedingContract'"
    [textConfirm]="'Kostenpflichtig bestellen'"
    [actionReject]="null"
    [message]="'Sind Sie sicher, dass Sie den das Einspeisermanagement kostenpflichtig bestellen möchten?'"
    [errorFormList]="errorFormList"
    (onActionClickedEvent)="actionToRun($event)"></app-form-confirmation>
</app-default-card>
